import React from 'react';
import {
    Button,
    CaretDownOutlined,
    CaretUpOutlined,
    Box,
} from '@landr/maestro';
import { t } from '@lingui/macro';
import { useSuggestionsPillsContext } from '../context/SuggestionsPillsContext';

export const ViewMoreButton = ({
    isSuggestionsPillsOpen,
    toggle,
    buttonRef,
}: {
    isSuggestionsPillsOpen: boolean;
    toggle: () => void;
    buttonRef: React.RefObject<HTMLDivElement>;
}) => {
    const { hasOverflow } = useSuggestionsPillsContext();

    return (
        <Box
            ref={buttonRef}
            data-suggestions-pills-view-more-button
            style={{
                position: 'absolute',
                bottom: '0',
                right: '0',
                zIndex: 1,
                visibility: hasOverflow ? 'visible' : 'hidden',
            }}
        >
            <Button
                onClick={toggle}
                size="xs"
                kind="link"
                variant="secondary"
                iconRight={
                    isSuggestionsPillsOpen ? CaretUpOutlined : CaretDownOutlined
                }
                isRounded
                marginLeft="xs"
            >
                {isSuggestionsPillsOpen ? t`Show less` : t`Show more`}
            </Button>
        </Box>
    );
};
